// extracted by mini-css-extract-plugin
export default {"root":"root___pyzUF","content":"content___BGMv_","link":"link___QlUQ1","main":"main___t9QOP","title":"title___v9z5X","contentBody":"contentBody___d1_it","footer":"footer___dWlib"};